var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewProof(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30.02 30.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f57224;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.5,27.02h12.32c3.17,1.02,6.63.47,9.32-1.49l4.1,4.1c.24.25.58.39.92.38h0c.34,0,.67-.14.91-.38l.56-.56c.51-.5.52-1.32.01-1.83,0,0,0,0-.01-.01l-4.1-4.1c3.39-4.69,2.34-11.24-2.35-14.63-.96-.69-2.03-1.22-3.17-1.56v-2.74c0-.26-.1-.52-.29-.71l-3.21-3.21C16.33.1,16.07,0,15.81,0H1.5C.67,0,0,.67,0,1.5v24.02C0,26.35.67,27.02,1.5,27.02ZM28.93,27.95c.06.06.09.13.09.21,0,.08-.03.15-.09.21l-.56.56c-.05.06-.13.09-.21.09h0c-.08,0-.16-.03-.21-.09l-4.02-4.02c.35-.31.68-.63.98-.98l4.02,4.02ZM26.52,17.01c0,5.25-4.26,9.51-9.51,9.51s-9.51-4.26-9.51-9.51,4.26-9.51,9.51-9.51c5.25,0,9.5,4.26,9.51,9.51ZM16.51,1.71l1.8,1.79h-1.3c-.28,0-.5-.22-.5-.5v-1.29ZM1,1.5c0-.28.22-.5.5-.5h14.01v2c0,.83.67,1.5,1.5,1.5h2v2.2c-5.69-1.11-11.2,2.6-12.31,8.29-.85,4.35,1.12,8.76,4.93,11.03H1.5c-.28,0-.5-.22-.5-.5V1.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.51,17.01c0,4.7,3.81,8.51,8.51,8.51,4.7,0,8.51-3.81,8.51-8.51,0-3.67-2.36-6.93-5.85-8.08-.26-.09-.55.06-.63.32-.09.26.06.55.32.63,3.94,1.3,6.08,5.54,4.79,9.48-1.3,3.94-5.54,6.08-9.48,4.79-3.94-1.3-6.08-5.54-4.79-9.48,1.01-3.08,3.89-5.16,7.13-5.16.28,0,.5-.22.5-.5s-.22-.5-.5-.5c-4.7,0-8.5,3.81-8.51,8.51Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.5,3.5h10.01c.28,0,.5-.22.5-.5s-.22-.5-.5-.5H3.5c-.28,0-.5.22-.5.5s.22.5.5.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.5,6h10.01c.28,0,.5-.22.5-.5s-.22-.5-.5-.5H3.5c-.28,0-.5.22-.5.5s.22.5.5.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.5,8.51h5.5c.28,0,.5-.22.5-.5s-.22-.5-.5-.5H3.5c-.28,0-.5.22-.5.5s.22.5.5.5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.5,11.01h3c.28,0,.5-.22.5-.5s-.22-.5-.5-.5h-3c-.28,0-.5.22-.5.5s.22.5.5.5Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.5,13.51h2c.28,0,.5-.22.5-.5s-.22-.5-.5-.5h-2c-.28,0-.5.22-.5.5s.22.5.5.5Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.5,16.01h1.5c.28,0,.5-.22.5-.5s-.22-.5-.5-.5h-1.5c-.28,0-.5.22-.5.5s.22.5.5.5Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.5,18.51h1.5c.28,0,.5-.22.5-.5s-.22-.5-.5-.5h-1.5c-.28,0-.5.22-.5.5s.22.5.5.5Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.5,21.02h2c.28,0,.5-.22.5-.5s-.22-.5-.5-.5h-2c-.28,0-.5.22-.5.5s.22.5.5.5Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.5,23.52h3c.28,0,.5-.22.5-.5s-.22-.5-.5-.5h-3c-.28,0-.5.22-.5.5s.22.5.5.5Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.98,16.82c-.09-.12-2.23-3.01-4.97-3.01s-4.88,2.89-4.97,3.01c-.09.12-.09.27,0,.39.09.12,2.23,3.01,4.97,3.01s4.88-2.89,4.97-3.01c.09-.12.09-.28,0-.39ZM17.01,19.56c-2.02,0-3.76-1.92-4.28-2.54.52-.63,2.26-2.54,4.28-2.54s3.76,1.92,4.28,2.54c-.52.63-2.26,2.54-4.28,2.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.01,15.02c-1.1,0-1.99.89-1.99,1.99s.89,1.99,1.99,1.99,1.99-.89,1.99-1.99-.89-1.99-1.99-1.99ZM17.01,18.34c-.73,0-1.33-.6-1.33-1.33s.6-1.33,1.33-1.33,1.33.6,1.33,1.33-.6,1.33-1.33,1.33Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewProof);
export default __webpack_public_path__ + "static/media/view_proof.34411ceabbd3ef16adbb07bce73681f8.svg";
export { ForwardRef as ReactComponent };